<template lang="pug">
shListData(title="Reportes" resolver="feedbacks" keyData="feedback" component="shFeedback")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Feedbacks',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/feedback/Feedbacks.vue